import styled from "styled-components";

export const Main = styled.div`
   width: 150px;
   padding: 0;
`;

export const Styled = styled.div`
   max-width: 440px;
   width: 100%;
   display: flex;
   flex-direction: column;
   gap: 10px;

   .row {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 8px;
   }

   .selectField {
      width: 100%;
      border: 1px solid #ddd;
      border-radius: 4px;
      padding: 9px 10px;
      background: #fff;
      color: #222;
      font-size: 14px;
      outline: none;
   }

   .label {
      margin: 0 0 -4px;
      color: #444;
      font-size: 13px;
      font-weight: 600;
   }

   .templatePickerSection {
      display: flex;
      flex-direction: column;
      gap: 8px;
      padding: 10px;
      border: 1px solid #e5edf8;
      border-radius: 8px;
      background: #fcfdff;
   }

   .sectionHeader {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
   }

   .templatePickerRow {
      display: flex;
      align-items: stretch;
   }

   .languageBadge {
      display: inline-flex;
      align-items: center;
      min-height: 24px;
      padding: 0 8px;
      border-radius: 999px;
      border: 1px solid #c7d7ee;
      background: #eef4ff;
      color: #35507a;
      font-size: 11px;
      font-weight: 700;
   }

   .templateSummary {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
   }

   .templateSummary span {
      display: inline-flex;
      align-items: center;
      min-height: 24px;
      padding: 3px 8px;
      border-radius: 6px;
      background: #ffffff;
      border: 1px solid #e2eaf5;
      color: #4b5563;
      font-size: 11px;
      font-weight: 600;
   }

   .templatePreviewCard {
      border: 1px solid #d9e2f1;
      border-radius: 8px;
      overflow: hidden;
      background: #fbfdff;
   }

   .accordionHeader {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
      padding: 10px 12px;
      border: 0;
      background: #f4f8ff;
      color: #1f3b64;
      font-size: 13px;
      font-weight: 600;
      cursor: pointer;
      text-align: left;
   }

   .arrow {
      font-size: 10px;
      color: #6b7280;
      transform: rotate(-90deg);
      transition: transform 0.2s ease;
   }

   .arrow.expanded {
      transform: rotate(0deg);
   }

   .accordionContent {
      display: flex;
      flex-direction: column;
      gap: 10px;
      padding: 12px;
   }

   .templateMetaRow {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 10px;
   }

   .templateMetaRow > div {
      display: flex;
      flex-direction: column;
      gap: 4px;
      padding: 8px 10px;
      border-radius: 6px;
      background: #ffffff;
      border: 1px solid #e5edf8;
   }

   .metaLabel {
      color: #64748b;
      font-size: 11px;
      font-weight: 600;
      text-transform: uppercase;
   }

   .metaValue {
      color: #1f2937;
      font-size: 13px;
      font-weight: 600;
   }

   .previewBlock {
      display: flex;
      flex-direction: column;
      gap: 6px;
      padding: 10px;
      border-radius: 6px;
      background: #ffffff;
      border: 1px solid #e5edf8;
   }

   .previewLabel {
      margin: 0;
      color: #334155;
      font-size: 12px;
      font-weight: 700;
   }

   .previewBlock pre {
      margin: 0;
      white-space: pre-wrap;
      word-break: break-word;
      font-family: Monaco, Menlo, "Ubuntu Mono", monospace;
      font-size: 12px;
      color: #0f172a;
   }

   .buttonList,
   .chipList {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
   }

   .buttonChip,
   .paramChip,
   .exampleChip {
      display: inline-flex;
      align-items: center;
      min-height: 28px;
      padding: 4px 8px;
      border-radius: 6px;
      font-size: 12px;
      line-height: 1.3;
   }

   .buttonChip {
      background: #eff6ff;
      color: #1d4ed8;
      border: 1px solid #bfdbfe;
   }

   .paramChip {
      background: #ecfeff;
      color: #155e75;
      border: 1px solid #a5f3fc;
      font-family: Monaco, Menlo, "Ubuntu Mono", monospace;
   }

   .exampleChip {
      background: #f8fafc;
      color: #334155;
      border: 1px solid #dbe4ee;
   }

   .helperText {
      margin: 0;
      color: #556070;
      font-size: 12px;
      line-height: 1.45;
   }
`;
